<template>
  <div class="dropdown-menu dropdown-menu-animated dropdown-lg" :class="elementClass" v-bind="$attrs">
    <slot></slot>
  </div>
</template>
<script setup>
import { computed } from 'vue'

// #region - Props
const props = defineProps({
  itemClass: {
    type: String,
    default: '',
    required: false
  },
  show: {
    type: String,
    default: '',
    required: true
  },
  right: {
    type: Boolean,
    default: true,
    required: false
  }
})
// endregion

// #region - computed properties
const elementClass = computed(() => {
  let bindedClass = `${props.itemClass} ${props.show}`
  if (props.right === true) {
    bindedClass = bindedClass + ` dropdown-menu-right`
  }
  return bindedClass
})
// endregion
</script>
<style scoped>
.dropdown-menu.show {
  visibility: visible;
  opacity: 1;
  margin-top: 0 !important;
}
</style>
